import React ,{useEffect} from "react";



function Footer(){
    

   
    return (<>
        <footer className=""style={{marginTop:"5.5rem"}}>
        <marquee direction="right" behavior="alternate" loop className="w-100 py-3 fixed-bottom bg-primary text-black">
            <h2 className="h1 w-25 text-white  text-white font-weight-bold food-title text-black text-center" >Food Delivery Is Open</h2>

            </marquee>
        </footer>
    </>)
}
export default Footer;